<script setup lang="ts">
import useLocale from '../../composables/useLocale';
import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBookOpen } from '@fortawesome/pro-solid-svg-icons';
library.add(faBookOpen);

type Emits = {
  (e: 'update:model-value', value: boolean | null): void;
};
const emit = defineEmits<Emits>();

type Props = {
  modelValue: boolean;
  hasAutoPageTurn?: boolean;
  hasMediaAvailable?: boolean;
};
const props = defineProps<Props>();
const { t } = useLocale();
const { smAndDown } = useDisplay();

const value = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:model-value', val),
});
</script>

<template>
  <v-list-item
    density="compact"
    :disabled="!hasMediaAvailable"
    data-testid="bp-setting-auto-page-turn"
    :title="hasAutoPageTurn && hasMediaAvailable ? t('label_autoplay_on') : t('label_autoplay_off')"
    :aria-label="hasAutoPageTurn && hasMediaAvailable ? t('label_autoplay_on') : t('label_autoplay_off')"
  >
    <template #prepend>
      <FontAwesomeIcon class="pr-3" icon="fa-solid fa-book-open" :size="!smAndDown ? 'xl' : 'lg'"></FontAwesomeIcon>
    </template>
    <template #append>
      <v-switch v-model="value" :disabled="!hasMediaAvailable" class="pl-4" color="primary" hide-details inset />
    </template>
    <template v-if="!hasMediaAvailable" #subtitle>
      <span>{{ t('no_media_playback') }}</span>
    </template>
  </v-list-item>
</template>

<style scoped lang="scss">
:deep(.v-switch__track) {
  opacity: 1;
}
:deep(.v-icon) {
  opacity: 1 !important;
}
:deep(.v-switch .v-switch__track) {
  background-color: rgb(var(--v-theme-secondary));
}
</style>
